import { render } from "./commentText.vue?vue&type=template&id=e8dcb298&ts=true"
import script from "./commentText.vue?vue&type=script&lang=ts"
export * from "./commentText.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__